import React from 'react'
import Home from '../pages/Home'
import About from '../pages/Aboutshort'
import Ongoing from '../pages/ongoing'
import Volenter from '../pages/Volenter'
import Help from '../pages/Helps'
import Contact from '../pages/Contact'

const HeroSection = () => {
  return (
    <div >
      <Home/>
      <About/>
      <Ongoing/>
      <Volenter/>
      <Help/>
      <Contact/>
      
    </div>
  )
}

export default HeroSection
